// extracted by mini-css-extract-plugin
export var container = "_2v-0";
export var error = "_2v-9";
export var label = "_2v-5";
export var light = "_2v-6";
export var md = "_2v-3";
export var sm = "_2v-2";
export var thin = "_2v-8";
export var thinBold = "_2v-7";
export var vertical = "_2v-4";
export var xs = "_2v-1";